<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  // 1. Prüfen, ob der Kunde den Hinweis in dieser Sitzung schon gesehen hat
  var alreadySeen = sessionStorage.getItem("cart_urgency_seen");

  // 2. 50% Zufallschance bei neuen Besuchern
  var isRandomHide = Math.random() < 0.5;

  if (alreadySeen || isRandomHide) {
    // Blendet den Countdown-Text aus
    var style = document.createElement("style");
    style.innerHTML = ".previewCart-countdown, .cart-countdown, [class*='countdown'] { display: none !important; }";
    document.head.appendChild(style);
  } else {
    // Merkt sich, dass der Text 1x gezeigt wurde
    sessionStorage.setItem("cart_urgency_seen", "true");
  }
});